enum WorkspaceProjectMilestoneReleaseStatus {
  draft = 'draft',
  pending = 'pending',
  completed = 'completed',
  failed = 'failed',
}

export default WorkspaceProjectMilestoneReleaseStatus
